export default __webpack_public_path__ + "static/media/emptyTasks.08389cd3.png";